<template>
    <AppLayout>
        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <!-- breadcrumb -->
            <nav
                class="mb-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link
                            :href="route('landing')"
                            class="text-gray-600"
                        >
                            Home
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                            >KYC</a
                        >
                    </li>
                </ol>
            </nav>
            <!-- breadcrumb end -->

            <div class="flex items-center justify-between mb-4">
                <div class="text-xl font-semibold md:text-2xl">KYC List</div>

                <div>
                    <t-select
                        v-model="filterBy"
                        placeholder="All"
                        :options="[
                            { text: 'Pending', value: 'pending' },
                            { text: 'Rejected', value: 'rejected' },
                            { text: 'Accepted', value: 'accepted' },
                        ]"
                    />
                </div>
            </div>

            <div v-if="kycs.data.length">
                <t-table
                    :responsive="true"
                    :responsive-breakpoint="640"
                    :headers="['Name', 'Role', 'Status', 'Submission Date', 'Accepted Date', 'Actions']"
                    :data="kycs.data"
                >
                    <template #row="props">
                        <tr :class="[props.trClass, props.rowIndex % 2 === 1 ? 'bg-gray-100' : '']">
                            <td :class="props.tdClass">
                                {{ props.row.person_name }}
                            </td>
                            <td :class="props.tdClass">
                                {{ props.row.user.roles[0].name }}
                            </td>
                            <td
                                v-if="!props.row.accepted_at && !props.row.deleted_at"
                                class="inline-block px-2 py-1 mt-1 text-sm text-white bg-yellow-400 rounded"
                            >
                                Pending
                            </td>
                            <td
                                v-else-if="!props.row.accepted_at && props.row.deleted_at"
                                class="inline-block px-2 py-1 mt-1 text-sm text-white bg-red-400 rounded"
                            >
                                Rejected
                            </td>
                            <td
                                v-else-if="props.row.accepted_at && !props.row.deleted_at"
                                class="inline-block px-2 py-1 mt-1 text-sm text-white bg-green-400 rounded"
                            >
                                Accepted
                            </td>
                            <td :class="props.tdClass">
                                {{ props.row.created_at | dateOnly }}
                            </td>
                            <td
                                v-if="props.row.accepted_at"
                                :class="props.tdClass"
                            >
                                {{ props.row.accepted_at | dateOnly }}
                            </td>
                            <td
                                v-else
                                :class="props.tdClass"
                            >
                                --
                            </td>
                            <td>
                                <div
                                    class="inline-flex px-3 py-1 text-white bg-green-500 border rounded cursor-pointer"
                                    @click="goto('kyc.show', { kycId: props.row.id })"
                                >
                                    <ViewIcon class="w-4 mr-2 fill-current" /> View
                                </div>
                            </td>
                        </tr>
                    </template>
                </t-table>

                <div class="my-4">
                    <t-pagination
                        v-model="currentPage"
                        :total-items="totalRows"
                        :per-page="perPage"
                        :limit="limit"
                        :disabled="disabled"
                        @change="fetchPageData"
                    />
                </div>
            </div>
            <div v-else>No KYC record available</div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from '../../Layouts/AppLayout.vue';
    import ViewIcon from '../../Components/Icons/ViewIcon.vue';

    export default {
        name: 'KycIndex',

        components: {
            AppLayout,
            ViewIcon,
        },

        props: {
            kycs: {
                type: Object,
                required: true,
            },
            filteredBy: {
                validator: (prop) => typeof prop === 'string' || prop === null,
                required: true,
            },
        },

        data() {
            return {
                currentPage: null,
                limit: 5,
                perPage: this.kycs.per_page,
                totalRows: this.kycs.total,
                filterBy: null,
                mounted: false,
            };
        },

        computed: {
            disabled() {
                return !this.kycs.data.length;
            },
        },

        watch: {
            filterBy() {
                if (this.mounted) {
                    this.fetchPageData();
                }
            },
        },

        created() {
            if (this.filteredBy) this.filterBy = this.filteredBy;
            this.currentPage = this.kycs.current_page;

            this.$nextTick(() => {
                this.mounted = true;
            });
        },

        methods: {
            fetchPageData(newPage = 1) {
                this.$inertia.get(
                    route('kyc.index', {
                        page: newPage,
                        filterBy: this.filterBy,
                    }),
                );
            },
        },
    };
</script>
